import React from 'react';
import styled, { css } from 'styled-components';
import {
  Divider as MuiDivider,
  IconButton as MuiIconButton,
  MenuItem as MuiMenuItem,
  Menu as MuiMenu
} from '@mui/material';
import Icons from '../Icons';

const ForwardRefComponent = React.forwardRef((props, ref) => <MuiIconButton {...props} ref={ref} />);

export const IconButton = styled(ForwardRefComponent).attrs({ className: 'dsc-verticalMenu-button' })`
  &:hover {
    path {
      fill: var(--icon-hover-color, var(--mediumGreen));
    }
  }
`;

export const Menu = styled(MuiMenu).attrs({ className: 'dsc-verticalMenu' })`
  && {
    .MuiPaper-root {
      backdrop-filter: var(--menu-popup-backdrop-filter, blur(26px));
      .MuiList-root {
        padding: var(--menu-popup-list-padding, 8px 0);
        .Mui-disabled {
          opacity: 0.38;
        }
      }
    }
  }
`;

export const MenuItem = styled(MuiMenuItem)`
  && {
    font-family: var(--app-font) Averta, sans-serif;
    font-size: 12px;
    font-weight: 400;
    line-height: normal;
    letter-spacing: 0.5px;
    //text-transform: uppercase;
    color: var(--select-text-color);
    transition: font-size 0.2s ease, color 0.2s ease;
    &:hover {
      background-color: var(--select-list-option-hover-bg);
    }

    ${({ $overrideCss }) =>
      $overrideCss &&
      css`
        ${$overrideCss}
      `}
  }
`;

export const Divider = styled(MuiDivider)`
  &&& {
    box-sizing: border-box;
    height: 4px;
    margin: 0 8px;
    border: none;
    border-bottom: 1px solid var(--platinum1);
  }
`;

export const ColoredCircle = styled.div`
  width: 9px;
  height: 9px;
  background-color: ${({ $color }) => $color};
  border-radius: 10px;
  margin-right: 8px;
`;

export const POPPER_STYLE = {
  maxHeight: 400,
  borderRadius: 'var(--popper-radius)',
  boxShadow: 'var(--menu-popup-shadow, 0px 2px 10px 0px #475B5E24)',
  color: 'var(--mainFontColor)',
  backgroundColor: `var(--menu-popup-list-bg-color)`
};

export const Element = styled.div``;

export const LoadingIcon = styled(Icons.InProgress).attrs({ size: 14, rotate: true, color: 'var(--mainGreen)' })`
  position: absolute;
  top: -2px;
  right: 2px;
`;
